<template>
    <div class="print-header">
        <div class="title">
            <div class="company-name">{{ companyName }}<span v-if="isTrying">（試用）</span></div>
            <div class="form-name">{{ year }} 年度年度預估營業淨收 - {{ formType }}</div>
        </div>
        <div class="print-date">製表日期：{{ dateOfToday }}</div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
    props: {
        year: {
            type: Number,
            default: 0,
        },
        formType: {
            type: String,
            default: '',
        },
    },
    computed: {
        ...mapGetters({ isTrying: 'menu/isTrying' }),
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
        dateOfToday() {
            return moment().format('YYYY-MM-DD');
        },
    },
};
</script>

<style lang="scss" scoped>
.print-header {
    margin-top: 30px;
    .title {
        text-align: center;
    }

    .print-date {
        font-size: 8pt;
        text-align: right;
        margin-top: 20px;
    }

    @media screen {
        display: none;
    }
}
</style>
